export default "__VITE_ASSET__C3W9gzxp__"